/**
 * @module services/api-upload/qbSnapshot
 * @description 从列信息与 base/draft 构建 QB 快照（visibility / convert 共用）
 */

import { ChartCalculateMode } from '@dbl/core/chartEditor';
import { detectDateDimensionsInList } from '../../manifest/dimensionDateUtils';
import type { QBStateSnapshot } from '../../types';
import type { IPrepareConfigInput } from './types';
import { normalizeRecord } from './normalize';
import {
  isCrosstabActive,
  type ICrosstabConfig,
} from '../../utils/crosstab';

export function buildQBSnapshotFromColumns(
  params: IPrepareConfigInput,
): QBStateSnapshot {
  const base = normalizeRecord(params.base);
  const draft = normalizeRecord(params.draft);
  const effectiveSortBy =
    'sortBy' in draft ? draft.sortBy : base.sortBy;
  const effectiveCrosstab = (draft.crosstab ?? base.crosstab) as
    | ICrosstabConfig
    | undefined;

  return {
    chartType: params.chartType,
    columnDimensions: params.columnDimensions ?? [],
    columnMetrics: params.columnMetrics ?? [],
    hasDateDimension: detectDateDimensionsInList(params.columnDimensions),
    mode:
      params.mode === ChartCalculateMode.RawColumn ? 'raw' : 'aggregation',
    sortType: String(effectiveSortBy ?? ''),
    dualYAxisEnabled: !!(draft.dualYAxisEnabled ?? base.dualYAxisEnabled),
    isCrosstabActive: isCrosstabActive(
      effectiveCrosstab,
      params.columnDimensions ?? [],
      params.columnMetrics ?? [],
    ),
  };
}
